module.exports = __webpack_public_path__ + "img/cta-right-particle-1.9fde7ab5.png";